var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2516 6.87651C14.0444 6.75402 14.8568 6.84761 15.5999 7.14788C16.3432 7.44821 16.9902 7.94457 17.4673 8.58519C17.9446 9.22605 18.2327 9.98569 18.2968 10.7804C18.3609 11.5751 18.1983 12.3706 17.8286 13.0782C17.4592 13.7856 16.8982 14.3762 16.2107 14.7872C16.0284 14.8961 15.8303 14.9983 15.6708 15.0806C15.625 15.1043 15.5824 15.1263 15.5442 15.1463C15.349 15.2489 15.2222 15.3239 15.1283 15.3977C15.0435 15.4642 15.007 15.5137 14.986 15.5549C14.9658 15.5948 14.9331 15.68 14.9331 15.856V17.1095C14.9331 17.4409 14.6644 17.7095 14.3331 17.7095H13.5331C13.2017 17.7095 12.9331 17.4409 12.9331 17.1095V15.856C12.9331 15.4142 13.0194 15.0103 13.203 14.6489C13.386 14.2887 13.6383 14.0247 13.8932 13.8246C14.1388 13.6317 14.4023 13.487 14.6141 13.3758C14.6794 13.3415 14.7392 13.3106 14.795 13.2818C14.9406 13.2066 15.0606 13.1445 15.1844 13.0705C15.5592 12.8465 15.8598 12.5278 16.0559 12.1523C16.2519 11.777 16.3369 11.3581 16.3033 10.9412C16.2696 10.5242 16.1183 10.1222 15.8633 9.77982C15.6081 9.43718 15.2584 9.16698 14.8506 9.00221C14.4427 8.83738 13.9947 8.78543 13.557 8.85306C13.1193 8.92069 12.7119 9.10473 12.3791 9.38198C12.2046 9.52735 12.0544 9.69522 11.9317 9.87962C11.7482 10.1555 11.4141 10.3322 11.0997 10.2275L10.3407 9.97467C10.0263 9.86996 9.8527 9.5276 10.0006 9.23107C10.2652 8.7007 10.6389 8.22871 11.0989 7.84542C11.7135 7.33335 12.4587 6.99902 13.2516 6.87651Z",
    fill: "#ffae00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 19.8763C13.1111 19.6002 13.335 19.3763 13.6111 19.3763H14.2587C14.5348 19.3763 14.7587 19.6002 14.7587 19.8763V20.5239C14.7587 20.8 14.5348 21.0239 14.2587 21.0239H13.6111C13.335 21.0239 13.1111 20.8 13.1111 20.5239V19.8763Z",
    fill: "#ffae00"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 1C6.8203 1 1 6.8203 1 14C1 21.1797 6.8203 27 14 27C21.1797 27 27 21.1797 27 14C27 6.8203 21.1797 1 14 1ZM3 14C3 7.92487 7.92487 3 14 3C20.0751 3 25 7.92487 25 14C25 20.0751 20.0751 25 14 25C7.92487 25 3 20.0751 3 14Z",
    fill: "#ffae00",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIconHover);
export default __webpack_public_path__ + "static/media/faq-icon-hover.84029a4d92c68205dd83023e048b7f74.svg";
export { ForwardRef as ReactComponent };